import {
	Http
}
from '../utils/http.js'
import {
	cache
} from '@/utils/cache.js';

class AgencyModel extends Http {
	constructor() {
		super();
		this._storageKeyName = `${this._storageKey}shop_id`;
	}

	cacheId(agency_id) {
		cache.set(this._storageKeyName, agency_id);
	}

	getId() {
		return cache.get(this._storageKeyName)
	}

	register(data) {
		const params = {
			url: '/agency/register',
			data,
			method: 'POST'
		}
		return this.request(params)
	}

	salesInfo(sales_id) {
		const params = {
			url: '/agency/sales_info',
			data: {
				sales_id
			},
			method: 'POST'
		}
		return this.request(params)
	}

	// 是就返回我代理id不是就0
	getMyAgencyId() {
		const params = {
			url: '/agency/getMyAgencyId'
		}
		return this.request(params)
	}

	getShopData(id) {
		const params = {
			url: '/agency/shop_data',
			method: 'POST',
			data: {
				id
			}
		}
		return this.request(params)
	}

	getShopBaseInfo(id) {
		const params = {
			url: '/agency/shop_base_info',
			method: 'POST',
			data: {
				id
			}
		}
		return this.request(params)
	}
}
export {
	AgencyModel
}
